import _ from 'lodash';
import { createClient } from '@/shared/api';
import type { ClinicNotificationsQuery, ClinicNotificationsQueryVariables } from '@/shared/api';
import CLINIC_NOTIFICATIONS_QUERY from '../queries/clinicNotifications';

/**
 * Loads the paged list of clinic notifications for a filter. Runs the clinicNotifications query with the filter and limit and throws the first GraphQL error only when nothing came back.
 *
 * @param filter - Filter selecting the notifications.
 * @param limit - Maximum number of notifications to load; defaults to 10.
 * @returns A promise resolving to the clinic notifications payload.
 */
const fetchClinicNotifications = async (filter: Record<string, unknown>, limit: number = 10) => {
  const client = createClient();
  const result = await client.query<ClinicNotificationsQuery, ClinicNotificationsQueryVariables>({
    query: CLINIC_NOTIFICATIONS_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  const { data, errors } = result;
  const { clinicNotifications } = data;
  if (_.isNil(clinicNotifications) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return clinicNotifications;
};

export default fetchClinicNotifications;
